import React from "react";
import ReactApexChart from "react-apexcharts";

let colors = ["#c7d95f", "#f5e07f", "#fed38c", "#f0a24f", "#fc5805"];

export default class InteractivePieChart extends React.Component {
  render() {
    const chartOptions = {
      chart: {
        type: "pie",
        background: "#DEEBF7", // Set the background color here

      },
      colors: colors,
      labels: this.props.pie_categories,
      legend: {
        position: "bottom", // Adjust the legend position
        horizontalAlign: "center", // Center the legend
        itemMargin: {
          horizontal: 5,
          vertical: 0,
        },
      },
    };

    return (
      <div id="chart">
        <ReactApexChart
          options={chartOptions}
          series={this.props.series}
          type="pie"
          width={300} // Set the width of the chart
          height={300} // Set the height of the chart
        />
      </div>
    );
  }
}

